module.exports = __webpack_public_path__ + "static/media/yushan_package.bd2a188e.png";